import React from 'react';
import { useIntl } from 'react-intl';
import { generatePath, Link, useParams } from 'react-router-dom';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Cards from '@/pages/dokkaPay/pages/company/components/PaymentsWorkspace/components/SubscribeScreen/components/Cards';
import DokkaPayTitleText from '@/pages/dokkaPay/pages/company/components/PaymentsWorkspace/components/DokkaPayTitleText';

import WindowImage from '@/pages/dokkaPay/pages/company/components/PaymentsWorkspace/components/SubscribeScreen/images/Window.svg';

import ROUTES_PATH from '@/router/routesPathConfig';

const SubscribeScreen: React.FC = () => {
  const { formatMessage } = useIntl();
  const { companyId } = useParams();

  const link = generatePath(ROUTES_PATH.PAY_COMPANY_SETTINGS_PROVIDERS.absolute, { companyId });

  return (
    <Stack
      sx={{
        background: `url("${WindowImage}") scroll no-repeat 100% 0/contain`,
        backgroundSize: 'auto 55%',
        maxWidth: 1080,
        maxHeight: 700,
        width: '100%',
      }}
      justifyContent="space-between"
      height="100%"
    >
      <Stack maxWidth={500} spacing={2} alignItems="flex-start">
        <DokkaPayTitleText />
        <Typography variant="h4" color="primary.dark">
          {formatMessage({
            id: 'company.paymentsWorkspace.subTitle',
            defaultMessage: 'You haven\'t subscribed to this service yet',
          })}
        </Typography>
        <Typography variant="body1">
          {formatMessage({
            id: 'company.paymentsWorkspace.description',
            defaultMessage:
              'Ready to streamline your vendor payments? Simply subscribe to our service and we\'ll create your dedicated payment account. This account will allow you to easily pay your vendors with our secure platform. Click "Subscribe" to get started!',
          })}
        </Typography>
        <Button component={Link} to={link}>
          {formatMessage({ id: 'button.subscribe', defaultMessage: 'Subscribe' })}
        </Button>
      </Stack>
      <Cards />
    </Stack>
  );
};

export default SubscribeScreen;
